import { useMemo} from 'react';
import { useQuery, keepPreviousData} from "@tanstack/react-query";
import Slider from "react-slick";
import { SlickProps } from '../../lib/Slick';
import { Link, useParams } from "react-router-dom";
import BookListItem from '../books/components/BookListItem';
import Api from 'utils/api/Api';
import { Loading } from 'app/components/Loading';

export const VideoPopularBooks = ()=>{
    const { school } = useParams();
    
    const {data:youtubePopular, isLoading, isError  } = useQuery({
        queryKey:['video/popular/list'], 
        queryFn:()=>Api.get(`/api/youtube/popular/books`),
        staleTime:1000 * 60 * 5, 
        placeholderData:keepPreviousData
    });

    const list = useMemo(()=>{
        if(isLoading)return <Loading />;
        return youtubePopular?.data?.map((book)=>{
            return (
                <div className="slide_item" key={book.isbn}>
                    <Link to={`/${school}/book/${book.isbn}/video`} >
                        <BookListItem book={book} />
                    </Link>
                </div>
            )
        });
    }, [school, isLoading, youtubePopular]);

    if(isError || youtubePopular?.data?.length===0) return null;
    return (
        <div className="inner">
            <h3 className="alignC"><span>독서영상 인기 도서</span></h3>
            <Slider key="list" className="slider_wrap popular_list" {...SlickProps} dots={false} infinite={youtubePopular?.data?.length>4}>
                {list}
            </Slider>
        </div>
        );
};